import { render, staticRenderFns } from "./team-member-block.vue?vue&type=template&id=1d85e495&scoped=true"
import script from "./team-member-block.vue?vue&type=script&lang=ts"
export * from "./team-member-block.vue?vue&type=script&lang=ts"
import style0 from "./team-member-block.vue?vue&type=style&index=0&id=1d85e495&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d85e495",
  null
  
)

export default component.exports